/*
 * @Description: 维护物料和组合混入
 * @Author: ChenXueLin
 * @Date: 2021-11-17 09:48:14
 * @LastEditTime: 2022-10-19 13:51:23
 * @LastEditors: ChenXueLin
 */
export default {
  data() {
    return {
      materialCombinationVisible: false,
      assignReasonVisible: false
    };
  },
  mixins: [],
  components: {},
  computed: {},
  watch: {},
  created() {},
  activated() {},
  methods: {
    handleCombination() {
      this.materialCombinationVisible = true;
    }
     ,
    openAssignReason() {
      if (!this.itemIdList.length) {
        this.$message.warning("请先勾选任务项");
        return;
      }
      if (
          !this.itemList.every(item => {
            return item.itemStatusCode == 1;
          })
      ) {
        this.$message.warning("只有未分配的任务项才能设置派单原因");
        return;
      }
      this.assignReasonVisible = true;
    }
  }
};
